<div class="h-100">
  <div class="call-to-action">
    <button mat-icon-button (click)="back()">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <div>Select time slot</div>
  </div>

  @if (treatment) {
    <div class="inner-container">
      <div class="d-flex flex-column justify-content-between h-100 bg-red">
        @if (selectedNearestStaff && selectedNearestTime && selectedNearestTime.length) {
          Your selected appointment
        }
        @if (!(selectedNearestStaff && selectedNearestTime && selectedNearestTime.length)) {
          <p class="mt-3">{{ treatment.name }}
            with
            @if (selectedStaff && selectedStaff.firstname) {
              <span>{{ selectedStaff.firstname }} {{ selectedStaff.lastname }}</span>
            } @else {
              any available practioner
            }
          </p>
        }
        <div class="component-container">
          <div class="calendar-container ">
            <div class="d-flex justify-content-center">
              <button mat-icon-button (click)="previousDay()">
                <mat-icon>chevron_left</mat-icon>
              </button>
              <mat-form-field class="date-pick">
                <input  matInput
                  [matDatepicker]="picker"
                  [formControl]="datePicker"
                  [min]="today"
                  (dateInput)="dateInput($event)"
                  (dateChange)="dateChange($event)">
                  <mat-hint>DD/MM/YYYY</mat-hint>
                  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker>
                  </mat-datepicker>
                </mat-form-field>
                <button mat-icon-button (click)="nextDay()">
                  <mat-icon>chevron_right</mat-icon>
                </button>
              </div>
            </div>
            <div class="time-select-container">
              <div class="avail-times d-flex justify-content-left flex-wrap">
                <div class="showdate text-center">{{ nearestStart.toJSDate()| date : "fullDate" }}</div>
                @for (time of nearestTimes; track time) {
                  <button class="nearestStaff m-3 p-2"
                    (click)="nearestTimeSelected(time)"
                    mat-button>
                  {{time.startTime | date : 'HH:mm'}}
                </button>
              }
              @if (nearestTimes && nearestTimes.length==0) {
                <div class="text-center no-avail">
                  No availability on this date please try another.
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  }
</div>